module.exports = __webpack_public_path__ + "img/img_placeholder.e2ff299a.svg";